import React from 'react';
import PropTypes from "prop-types";

import Navigation from 'components/Navigation';
import Filter from './Filter/';
import ResultList from './ResultList/';
import {Row, Col} from 'reactstrap';

class Catalogue extends React.Component {
    static propTypes = {
        operator: PropTypes.object.isRequired,
        dateFrom: PropTypes.object,
        dateTo: PropTypes.object,
        searchTerm: PropTypes.string,
        availableAds: PropTypes.array.isRequired,
        ad: PropTypes.number,
        contacts: PropTypes.array.isRequired,
        totalContacts: PropTypes.number.isRequired,
        onOnlineChange: PropTypes.func.isRequired,
        onLogout: PropTypes.func.isRequired,
        onChangeDateFrom: PropTypes.func.isRequired,
        onChangeDateTo: PropTypes.func.isRequired,
        onChangeSearchTerm: PropTypes.func.isRequired,
        onChangeSearchOnlyAd: PropTypes.func.isRequired,
        onLoadMoreContacts: PropTypes.func.isRequired
    };

    render() {
        const {operator, dateFrom, dateTo, searchTerm,
            availableAds, ad, contacts, totalContacts,
            onOnlineChange, onLogout, onChangeSearchTerm, onChangeSearchOnlyAd,
            onChangeDateFrom, onChangeDateTo, onLoadMoreContacts} = this.props;

        return (
            <Row>
                <Col xs={12} md={4} xl={3} className="col-sidebar">
                    <Navigation user={operator} onOnlineChange={onOnlineChange} onLogout={onLogout}/>
                    <Filter dateFrom={dateFrom} dateTo={dateTo} searchTerm={searchTerm} ad={ad} availableAds={availableAds} onChangeSearchTerm={onChangeSearchTerm} onChangeSearchOnlyAd={onChangeSearchOnlyAd}
                            onChangeDateFrom={onChangeDateFrom} onChangeDateTo={onChangeDateTo}/>
                </Col>
                <Col xs={12} md={8} xl={9} className="content">
                    <ResultList contacts={contacts} totalContacts={totalContacts} onLoadMoreContacts={onLoadMoreContacts}/>
                </Col>
            </Row>
        );
    }
}

export default Catalogue;


// WEBPACK FOOTER //
// ./src/containers/Catalogue/Catalogue.jsx